export default "__VITE_ASSET__7055af9c__"